<template>
  <div class="evaluation" >
    <div class="content" :class="{'has_qrcode':cData.img}">
        <div class="title">
        <p>
          <span>您的评价会让我们做的更好</span>
        </p>
        <p>
          <span class="line"></span>
          <span>请对本次课程进行评价</span>
          <span class="line"></span>
        </p>
      </div>
      <div class="write">
        <div class="line" v-if="cData.img"></div>
        <div class="left" v-if="cData.img" v-append="cData.img"><p>扫码报名</p></div>
        <div class="right">
          <div class="start">
            <star :star="starNumber" @getCount="getCount"/>
          </div>
          <div :class="['commentBox', ,isFocusd?'commentBox--focus':'']">
            <textarea
              @focus="inputFocus"
              @blur="inputBlur"
              v-model="comment"
              :class="['desc', isFocusd?'desc--scroll':'']"
              placeholder="请输入评价噢～"
              maxlength="100"
              name="desc"
            ></textarea>
            <span>剩余{{100-comment.length}}字</span>
          </div>
          <div class="btns">
            <button @click="cancel" class="cancel cursor">取消评价</button>
            <button  @focus="sumbit('focus')"  @click="sumbit('click')" :class="['sumbit',starNumber>0?'':'sumbit--forbid','cursor']">提交评价</button>
          </div>
        </div>
      </div>
    </div>
    <!--评价卡片-->
    <Card v-if="showCard" :mode="cardMode" @cardCallBack="cardCallBack"/>
    <loading v-if="loadingShow"></loading>
  </div>
</template>
<script>
import Star from "../../basic/star/star";
import utils from "utils";
import Card from "../../basic/card/card"; //卡片
import { mapMutations } from "vuex";
import loading from '@/components/basic/loading.vue';
export default {
  data() {
    return {
      starNumber: 0, //选中的星星个数默认为0
      comment: "",
      isFocusd: false,
      cardMode: "success",
      showCard: false,
      loadingShow:false,
    };
  },
  props: {
    cData: {
      type: Object,
      required: true
    }
  },
  components: {
    Star,
    Card,
    loading
  },
  created(){
    this.$root.eventHub.$on("stu_comment_result",(type)=>{
      this.cardMode = type;
      this.showCard = true;
      this.loadingShow = false;
    })
  },
  methods: {
    ...mapMutations(["refreshNet"]),
    //卡片关闭页面
    cardCallBack(type) {
      if (type == "success") {
        this.$emit("toggleComment", false);
      } else {
        this.showCard = false;
      }
    },
    cancel() {
      this.$emit("toggleComment", false);
    },
    getCount(count) {
      this.starNumber = count;
    },
    inputFocus() {
      this.isFocusd = true;
    },
    inputBlur() {
      if (utils.realLength(this.comment) > 38) return;
      this.isFocusd = false;
    },
    sumbit(type) {
      if(type==='click'){
        let isSafari=/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if(!isSafari)return;
      }
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      if (this.starNumber == 0) return;
      this.loadingShow = true;
      this.$root.eventHub.$emit("stu_comment", {
        mark: this.starNumber, // 星级1-5
        comment: this.comment,
        recv_unique_id: this.cData.unique_id
      });
    }
  },
  beforeDestroy() {
    this.$root.eventHub.$off("stu_comment_result")
  },
  directives:{
    append:{
      inserted (el,binding) {
        el.appendChild(binding.value)
      }
    }
  },
};
</script>
<style lang="less" scoped>
.evaluation {
  background: #fff;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 89;
  left: 0;
  top: 0;
  box-sizing: border-box;
  background: #008acf;
  .content {
    margin: 0 auto;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .title {
    font-family: PingFang_Medium;
    font-size: 22px;
    height: 300px;
    padding-top: 150px;
    color: #fff;
    p {
      color: #fff;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:first-child {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 18px;
        line-height: 34px;
        font-size: 34px;
      }
      span {
        margin: 0 10px;
      }
      .line {
        margin: 0;
        background: rgba(255,255,255,.4);
        height: 1px;
        display: inline-block;
        width: 40px;
      }
    }
  }
  .write{
    flex:1;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 12px 12px 12px 12px;
    .start{
      width :400px;
      margin: 70px auto 0;
    }
    .commentBox {
      position: relative;
      margin: 50px auto 52px;
      border: 1px solid #D6D6D6;
      border-radius: 8px;
      width: 663px;
      height: 150px;
      padding-left: 5px;
      overflow: hidden;
      .desc {
        width: 100%;
        height: 100%;
        font-size: 20px;
        border-radius: 8px;
        resize: none;
        padding: 18px 18px;
        overflow-y: hidden;
        font-family: PingFang_Regular;
      }
      span {
        display: none;
      }
    }
    .commentBox--focus {
      .desc {
        line-height: 24px;
        overflow-y: scroll;
        padding: 18px 18px;
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 6px;
          box-shadow: inset 0 0 5px #d7d7d7;
          background: #d7d7d7;
          //   -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        }
        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          background: #fff;
          // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        }
      }
      span {
        position: absolute;
        bottom: 0px;
        right: 10px;
        font-size: 16px;
        color: #c9c9c9;
        letter-spacing: 0;
        display: inline;
      }
    }
    .btns{
      display: flex;
      align-items: center;
      justify-content: center;
      .sumbit {
        width: 186px;
        background: #008acf;
        box-sizing: border-box;
        border-radius: 12px;
        color: #fff;
        height: 64px;
        font-family:  PingFang_Regular;
        font-size: 24px;
        line-height: 64px;
        text-align: center;
        &:hover {
          background: #008acb;
        }
      }
      .sumbit--forbid {
        &:hover {
          background: #008acf;
        }
        background: #008acf;
      }
      .cancel {
        font-family:  PingFang_Regular;
        width: 186px !important;
        height: 64px;
        box-sizing: border-box;
        border-radius: 12px;
        color: #008acf;
        width: 100px;
        font-size: 24px;
        line-height: 64px;
        text-align: center;
        align-self: center;
        border: 2px solid #008acf;
        margin-right: 24px;
        &:hover {
          color: #008acf;
        }
      }
    }
  }
  .has_qrcode{
    .title{
      transform: translateX(120px);
    }
    .write{
      justify-content: center;
      flex-direction: row;
      .left{
        width: 200px;
        margin-top: 140px;
        margin-right: 240px;
        position: relative;
        text-align: center;
        /deep/img{
          width: 150px;
          height: 150px;
          position: absolute;
          left:25px;
          top: 0;
        }
        p{
          padding-top: 165px;
          color: #333333;
          font-size: 18px;
        }
      }
      .line{
        position: absolute;
        height: 100%;
        top: 0;
        left: 50%;
        width: 1px;
        margin-left: -250px;
        border-right: 1px dashed #dcdcdc;
      }
    }
  }
  @media screen and (max-height: 800px) {
    .title {
      p:first-child{
        font-size: 26px;
        margin-bottom: 10px;
      }
      height: 200px;
      padding-top: 95px;
      font-size: 16px;
    }
    .has_qrcode {
      .write{
        .left{
          margin-top: 40px;
          margin-right: 120px;
        }
        .start{
          width :400px;
          margin: 20px auto 0;
        }
        .line{
          margin-left: -155px;
        }
        .commentBox{
          margin: 20px auto 20px;
          height: 100px;
          width: 500px;
        }
        .btns{
          .sumbit{
            width: 140px;
            height: 60px;
            line-height: 60px;
            font-size: 22px;
          }
          .cancel{
            width: 140px !important;
            height: 60px;
            line-height: 59px;
            font-size: 22px;
          }
        }
      }
    }
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/evaluation.vue